module.exports = __webpack_public_path__ + "media/kartenadd.c5731c61.mp4";